import React, { Component } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { withRouter } from '~HOC';
import { validateForm, validation } from '../../../utils/validation';
import { profileDepartmentApi } from '../../../services/apis';
import { connect } from 'react-redux';
import {
  Input,
  Button,
  Confirmation,
  ValidationMessage,
  Toast,
} from '../../../component';

const INITIAL_DATA = {
  persianName: '',
  englishName: '',
  code: '',
  profileId: '',
};

class DepartmentManagement extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: structuredClone(INITIAL_DATA),
      errors: { persianName: [], englishName: [], code: [] },
      alertMessage: 'department.departmentadd',
      toastState: 'success',
      alertType: '',
      alertBody: '',
      isShowAlert: false,
      loading: false,
      showModal: false,
      toast: false,
    };
  }

  addDepartment = async () => {
    const { persianName, englishName, code } = this.state.data,
      { profileId = '', updateDepartmentList } = this.props;
    try {
      this.setState({ loading: true });

      await profileDepartmentApi.insert({
        data: {
          name: { fa: persianName, en: englishName },
          code,
          profileId,
        },
      });
      this.setState(
        {
          data: { ...INITIAL_DATA },
        },
        () => updateDepartmentList(true),
      );
    } catch (error) {
      this.setState({
        loading: false,
        toast: true,
        alertMessage: 'user.tryagain',
        toastState: 'success',
      });
    }
  };

  validate = () => {
    const { persianName, englishName, code } = this.state.data;
    const { error, result } = validateForm({
      persianName: validation.persian(persianName).required().errors,
      englishName: validation.english(englishName).required().errors,
      code: validation.number(code).required().errors,
    });

    return { error, result };
  };

  render() {
    const {
        isShowAlert,
        alertBody,
        alertType,
        data,
        toast,
        alertMessage,
        toastState,
        errors,
        loading,
      } = this.state,
      {
        intl,
        language: { direction, name },
      } = this.props;
    return (
      <>
        {isShowAlert && (
          <Confirmation
            isConfirmation={false}
            onReject={() => this.setState({ isShowAlert: false })}
            show={isShowAlert}
            type={alertType}
            closeTime={2000}
            body={intl.formatMessage({ id: alertBody })}
            defaultDescription={intl.formatMessage({ id: alertBody })}
            title={intl.formatMessage({ id: alertBody })}
          />
        )}
        <div className="d-flex flex-column pt-md-0 pt-2 pb-3 px-0">
          <Toast
            isOpen={toast}
            onClose={() => this.setState({ toast: false })}
            state={toastState}
            position="bottom"
            message={intl.formatMessage({
              id: alertMessage,
            })}
            direction={direction}
          />
          <div className="col-12 d-flex flex-xs-row flex-column justify-content-start px-0">
            <div className="col-xs-6 col-12 d-flex flex-row justify-content-start align-items-center px-0 d-flex flex-row justify-content-center align-items-center">
              <figure
                className="d-flex flex-row justify-content-start"
                style={{ width: '19rem' }}
              >
                <img
                  alt="managing "
                  className="col-md-11 col-12 px-0 default-border-radius-small"
                  src={require('../../../content/images/elements/managing-page.png')}
                />
              </figure>
            </div>
            <div className="col-xs-6 col-12 d-flex flex-column justify-content-start align-items-start px-md-3 px-xs-0 px-3 pb-xs-0 pb-3">
              <span
                className={`font-sm-xxlarge font-normal text-primary pt-2  ${
                  name === 'fa' && 'text-nowrap'
                }`}
              >
                <FormattedMessage id="department.title" />
              </span>
              <div className="col-md-10 w-100 text-third text-start pt-md-4 pt-1 px-0">
                <p className="font-lg-small font-sm-msmall font-xs-xsmall font-msmall lineHeight">
                  <FormattedMessage id="profile.textDepartment" />
                </p>
              </div>
            </div>
          </div>
          <div className="col-12 px-0">
            <div className="d-flex flex-row flex-wrap col-12 px-0">
              <div className="col-sm-6 col-12">
                <Input
                  name="persianName"
                  type="text"
                  label={intl.formatMessage({
                    id: 'department.persianname',
                  })}
                  value={data['persianName']}
                  onChange={(e) => {
                    this.setState({
                      errors: {
                        ...errors,
                        persianName: validation
                          .persian(e.target.value)
                          .required().errors,
                      },
                      data: { ...data, persianName: e.target.value },
                    });
                  }}
                  className={'pb-sm-0 pb-3'}
                  themeMode="light"
                  outSideLabel={true}
                  outSideLabelClass="text-start"
                  outSideLabelPosition="top"
                  inputClassName={
                    'font-normal height-input-profile px-sm-3 px-3'
                  }
                />
                <ValidationMessage errors={errors?.persianName} />
              </div>
              <div className="col-sm-6 col-12">
                <Input
                  name="englishName"
                  type="text"
                  label={intl.formatMessage({
                    id: 'department.englishname',
                  })}
                  value={data['englishName']}
                  onChange={(e) => {
                    console.log('e.target.value ', e.target.value);
                    this.setState({
                      errors: {
                        ...errors,
                        englishName: validation
                          .english(e.target.value)
                          .required().errors,
                      },
                      data: { ...data, englishName: e.target.value },
                    });
                  }}
                  className={'pb-sm-0 pb-3'}
                  themeMode="light"
                  outSideLabel={true}
                  outSideLabelClass="text-start"
                  outSideLabelPosition="top"
                  inputClassName={
                    'font-normal height-input-profile px-sm-3 px-3'
                  }
                />
                <ValidationMessage errors={errors?.englishName} />
              </div>
            </div>
            <div className="d-flex flex-row flex-wrap col-12 px-0">
              <div className="col-sm-6 col-12">
                <Input
                  name="code"
                  label={intl.formatMessage({
                    id: 'department.code',
                  })}
                  value={data['code']}
                  onChange={(e) => {
                    this.setState({
                      errors: {
                        ...errors,
                        code: validation.number(e.target.value).required()
                          .errors,
                      },

                      data: { ...data, code: e.target.value },
                    });
                  }}
                  className={''}
                  islocalization={'true'}
                  themeMode="light"
                  outSideLabel={true}
                  outSideLabelClass="text-start"
                  outSideLabelPosition="top"
                  inputClassName={
                    'font-normal height-input-profile px-sm-3 px-3'
                  }
                />
                <ValidationMessage errors={errors?.code} />
              </div>
            </div>
            <div className="d-flex flex-sm-row flex-column-reverse justify-content-between pt-sm-4 pt-4 px-sm-0 px-3 mt-sm-0 mt-1">
              <Button
                name={`reset-data-button`}
                id={`reset-data-button`}
                label={intl.formatMessage({ id: 'profile.reload' })}
                className="btn-third mx-0  mx-sm-3 mb-2 mb-sm-0"
                onClick={() => this.setState({ data: { ...INITIAL_DATA } })}
              />
              <Button
                name={`add-depart-button`}
                id={`add-depart-button`}
                label={intl.formatMessage({ id: 'department.add' })}
                className=" btn-secondary mx-0  mx-sm-3 mb-5 mb-sm-0"
                disabled={!this.validate().result || loading}
                loading={loading}
                onClick={this.addDepartment}
              />
            </div>
          </div>
        </div>
      </>
    );
  }
}

function mapStateToProps(state) {
  return {
    language: state.language,
    user: state?.user?.userInfo ?? [],
  };
}

export default injectIntl(
  withRouter(connect(mapStateToProps)(DepartmentManagement)),
);
